import { toast } from 'sonner'

const UPDATE_TOAST_ID = 'sw-update'
let refreshRequested = false

function promptForUpdate(worker: ServiceWorker) {
	toast('New version available', {
		id: UPDATE_TOAST_ID,
		description: 'Tap to refresh.',
		duration: Infinity,
		action: {
			label: 'Refresh',
			onClick: () => {
				refreshRequested = true
				worker.postMessage({ type: 'SKIP_WAITING' })
			},
		},
	})
}

/**
 * Registers /sw.js (production only, so dev HMR is unaffected) and shows a
 * toast when a new worker is waiting. The page reloads only once the user
 * accepts and the new worker takes control.
 */
export function registerServiceWorker() {
	if (ENV.MODE !== 'production' || !('serviceWorker' in navigator)) return

	// Reload only when the user accepted the update, not on first install.
	let reloading = false
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (!refreshRequested || reloading) return
		reloading = true
		window.location.reload()
	})

	navigator.serviceWorker
		.register('/sw.js')
		.then((registration) => {
			if (registration.waiting && navigator.serviceWorker.controller) {
				promptForUpdate(registration.waiting)
			}
			registration.addEventListener('updatefound', () => {
				const installing = registration.installing
				installing?.addEventListener('statechange', () => {
					if (
						installing.state === 'installed' &&
						navigator.serviceWorker.controller
					) {
						promptForUpdate(installing)
					}
				})
			})
		})
		.catch((error) =>
			console.error('Service worker registration failed', error),
		)
}
